import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import {
  Purchases,
  LOG_LEVEL,
  CustomerInfo,
  PurchasesPackage,
  PurchasesOffering,
} from '@revenuecat/purchases-capacitor';

@Injectable({ providedIn: 'root' })
export class RevenueCatService {
  private offering: PurchasesOffering | null = null;

  async init() {
    if (!Capacitor.isNativePlatform()) return;

    Purchases.setLogLevel({ level: LOG_LEVEL.DEBUG });

    await Purchases.configure({
      apiKey: 'test_UWUFBhwkTUwxEyrHKAxnqpxTwAp',
    });
  }

  async loadOffering(): Promise<PurchasesPackage | null> {
    const offerings = await Purchases.getOfferings();

    console.log('Offerings:', offerings);

    this.offering = offerings.current;

    if (!this.offering) {
      console.error('No current offering');
      return null;
    }

    return this.offering.availablePackages[0] ?? null;
  }

  async purchase(pkg: PurchasesPackage): Promise<CustomerInfo> {
    const result = await Purchases.purchasePackage({
      aPackage: pkg,
    });

    return result.customerInfo;
  }

  async restore(): Promise<CustomerInfo> {
    const result = await Purchases.restorePurchases();
    return result.customerInfo;
  }

  async isPremium(): Promise<boolean> {
    const info = await Purchases.getCustomerInfo();
    return !!info.customerInfo.entitlements.active['premium'];
  }
}
